import axios from 'axios';
import exportedConfig from '../config';

export default axios.create({ baseURL: exportedConfig.samplesS3BaseUrl + '/samples/' });
